import { ImportedMoyen } from "@/types/moyen"

/**
    * Calcule les champs manquants pour un moyen donné
    * @param moyen - Le moyen à vérifier
    * @returns Liste des noms des champs manquants en français
*/
export function computeMissingFields(moyen: ImportedMoyen) {
    const missing: string[] = []
    if (!moyen.numero) missing.push('Référence du moyen')
    if (!moyen.nomMoyen) missing.push('Désignation')
    if (!moyen.categorie) missing.push('Zone')
    if (!moyen.sousCategorie) missing.push('Secteur')
    if (!moyen.fournisseur) missing.push('Fournisseur')
    if (!moyen.indiceOutil) missing.push('Indice Outil')
    if (!moyen.quantite) missing.push('Quantité')
    if (!moyen.piloteRealisationId) missing.push('Pilote Réalisation')
    if (!moyen.contactFournisseurId) missing.push('Contact Fournisseur')
    return missing
}